// A count of the secrets writes this client has made, so what reads the
// store's key names (the runner badge's "N secrets missing") asks again after
// one. Before this the badge kept "26 secrets missing" after a backup import
// put them all in (mac-mini-m6, 2026-10-25), until a reconnect.

/** The actions that change which keys or files a board's store holds. */
const SECRETS_WRITES: ReadonlySet<string> = new Set([
  'deploySecretsInit',
  'deploySecretsSet',
  'deploySecretsUnset',
  'deploySecretsSetFile',
  'deploySecretsUnsetFile',
  'secretFileEnvSet',
  'secretFileEnvUnset',
  'secretsImportBackupApply',
  'secretsInboxAnswer'
]);

let version = 0;
const listeners = new Set<() => void>();

/** Called with each action that succeeded on a runner. */
export function noteRunnerAction(action: string): void {
  if (!SECRETS_WRITES.has(action)) return;
  version += 1;
  for (const listener of listeners) listener();
}

/** For `useSyncExternalStore`. */
export function subscribeSecretsWrites(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export const secretsWritesVersion = (): number => version;
